"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _secKill = require("@/api/activity/secKill");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SecKillRefundPane',
  components: {
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    activityId: {
      type: Number,
      default: null
    },
    activityTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchForm: {
        orderSn: '',
        userId: null,
        dateRange: []
      },
      currentStatus: null,
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      exportLoading: false,
      detailDialogVisible: false,
      currentRow: null,
      actionLoading: false,
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      resPath: process.env.VUE_APP_IMAGE_PATH,
      activityImgUrl: '',
      vipGradeList: []
    };
  },
  mounted: function mounted() {
    if (this.activityId) {
      this.loadVipGradeList();
      this.loadActivityDetail();
      this.fetchData();
    }
  },
  methods: {
    loadVipGradeList: function () {
      var _loadVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGradeList = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name
                  };
                });
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取会员等级列表失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadVipGradeList() {
        return _loadVipGradeList.apply(this, arguments);
      }
      return loadVipGradeList;
    }(),
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) return userpic;
      return this.imgPath + userpic;
    },
    loadActivityDetail: function () {
      var _loadActivityDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, data, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _secKill.getSecKillDetail)(this.activityId);
            case 1:
              res = _context2.sent;
              data = res && res.data ? res.data : res;
              if (data && data.imgUrl) {
                this.activityImgUrl = data.imgUrl;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取秒杀活动详情失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadActivityDetail() {
        return _loadActivityDetail.apply(this, arguments);
      }
      return loadActivityDetail;
    }(),
    getImageUrl: function getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = this.resPath || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    getUserRankName: function getUserRankName(userRank) {
      var grade = this.vipGradeList.find(function (g) {
        return g.id === userRank;
      });
      return grade ? grade.name : '-';
    },
    getUserRankTagType: function getUserRankTagType(userRank) {
      var tagMap = {
        1: 'info',
        2: '',
        3: 'success',
        4: 'warning',
        5: 'danger'
      };
      return tagMap[userRank] || '';
    },
    handlePhoneUserSelect: function handlePhoneUserSelect() {
      this.currentPage = 1;
      this.fetchData();
    },
    returnTypeText: function returnTypeText(t) {
      if (t === 1) return '退款退货';
      if (t === 2) return '仅退款';
      return '-';
    },
    fetchData: function fetchData() {
      var _this = this;
      if (!this.activityId) return;
      this.tableLoading = true;
      var params = {
        page: this.currentPage,
        limit: this.pageSize,
        activityId: this.activityId,
        orderSn: this.searchForm.orderSn,
        userId: this.searchForm.userId
      };
      if (this.currentStatus !== null) params.returnStatus = this.currentStatus;
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.startDate = this.searchForm.dateRange[0];
        params.endDate = this.searchForm.dateRange[1];
      }
      (0, _secKill.getSecKillRefundList)(params).then(function (res) {
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
      }).catch(function (err) {
        _this.$message.error('获取退款单失败：' + (err.message || ''));
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.tableLoading = false;
      });
    },
    handleStatusChange: function handleStatusChange() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        orderSn: '',
        userId: null,
        dateRange: []
      };
      this.currentStatus = null;
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleView: function handleView(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    },
    handleAudit: function handleAudit(decision) {
      var _this2 = this;
      if (!this.currentRow) return;
      var reasonRefusal = '';
      if (decision === 5) {
        this.$prompt('请输入拒绝理由', '受理拒绝', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea'
        }).then(function (_ref) {
          var value = _ref.value;
          reasonRefusal = value || '';
          _this2.doAudit(decision, reasonRefusal);
        }).catch(function () {});
      } else {
        this.$confirm('确定受理通过此退款单？', '提示', {
          type: 'warning'
        }).then(function () {
          return _this2.doAudit(decision, '');
        }).catch(function () {});
      }
    },
    doAudit: function doAudit(decision, reasonRefusal) {
      var _this3 = this;
      this.actionLoading = true;
      (0, _secKill.auditSecKillRefund)({
        returnId: this.currentRow.returnId,
        decision: decision,
        reasonRefusal: reasonRefusal
      }).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.detailDialogVisible = false;
        _this3.fetchData();
      }).catch(function (err) {
        _this3.$message.error('操作失败：' + (err.message || ''));
      }).finally(function () {
        _this3.actionLoading = false;
      });
    },
    handleConfirm: function handleConfirm() {
      var _this4 = this;
      if (!this.currentRow) return;
      this.$confirm('确认执行退款？此操作将作废券并调用天财退款。', '严重提示', {
        type: 'warning',
        confirmButtonText: '确认退款',
        cancelButtonText: '取消'
      }).then(function () {
        _this4.actionLoading = true;
        (0, _secKill.confirmSecKillRefund)({
          returnId: _this4.currentRow.returnId
        }).then(function () {
          _this4.$message.success('退款成功');
          _this4.detailDialogVisible = false;
          _this4.fetchData();
        }).catch(function (err) {
          _this4.$message.error('退款失败：' + (err.message || ''));
        }).finally(function () {
          _this4.actionLoading = false;
        });
      }).catch(function () {});
    },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.exportLoading = true;
              _context3.prev = 1;
              this.$message.info('正在提交导出任务...');
              params = {
                activityId: this.activityId,
                orderSn: this.searchForm.orderSn,
                userId: this.searchForm.userId
              };
              if (this.currentStatus !== null) params.returnStatus = this.currentStatus;
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context3.next = 2;
              return (0, _secKill.exportSecKillRefund)(params);
            case 2:
              response = _context3.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请到导出日志查看下载');
              } else {
                this.$message.warning(response && response.message || '导出失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              this.$message.error('导出失败：' + (_t3.message || '网络异常'));
            case 4:
              _context3.prev = 4;
              this.exportLoading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    formatTime: function formatTime(t) {
      if (!t) return '-';
      var d = new Date(t);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    },
    refundStatusText: function refundStatusText(s) {
      var map = {
        0: '未受理',
        4: '同意退款',
        5: '已拒绝',
        6: '已退款',
        9: '已完成'
      };
      return map[s] != null ? map[s] : String(s);
    },
    refundStatusTagType: function refundStatusTagType(s) {
      var map = {
        0: 'info',
        4: '',
        5: 'danger',
        6: 'success',
        9: 'warning'
      };
      return map[s] != null ? map[s] : 'info';
    },
    handleDownloadInvoice: function handleDownloadInvoice(row) {
      var url = row.redPdfUrl || row.pdfUrl;
      if (url) window.open(url, '_blank');
    }
  }
};